module.exports = __webpack_public_path__ + "img/mail-04.af22ca93.svg";